AppName.Modules.ThemeModule = (function () {
  //Dependencies
  var core = AppName.Core;

  //////////////////////
  // Private Methods //
  ////////////////////
  var _revealOnScroll = function () {
    function revealOnScroll() {
      var $window = $(window),
        win_height_padded = $window.height() * 1.1;
      var scrolled = $window.scrollTop();
      // Showed...

      $(
        ".section-image-text:not(.first), .section-testimonials .testimonial .image-holder, .section-kick-science .container, .section-about-action .container, .about .section-look-whos-talking .logo-list .logos .image-holder"
      ).each(function () {
        var $this = $(this),
          offsetTop = $this.offset().top - 200;
        if (scrolled + win_height_padded > offsetTop + $window.height() / 2) {
          if ($this.data("timeout")) {
            window.setTimeout(function () {
              $this.addClass("animate-fadeInUp");
            }, parseInt($this.data("timeout"), 10));
          } else {
            $this.addClass("animate-fadeInUp");
          }
        }
      });
    }
    document.addEventListener("scroll", function () {
      revealOnScroll();
    });
  };

  // var _scrollToGetStarted = function () {
  //   $(".btn-get-started").click(() => {
  //     $(window).scrollTo("#get-started", 1500);
  //   });
  // };

  // var _homePressSwiper = function () {
  //   var presSwiper = new Swiper(".press-swiper-container", {
  //     slidesPerView: 4,
  //     spaceBetween: 0,
  //     noSwiping: false,
  //     allowSlidePrev: false,
  //     allowSlideNext: false,
  //     pagination: {
  //       el: ".pres-pagination",
  //     },
  //     breakpoints: {
  //       767: {
  //         slidesPerView: 3,
  //         loop: true,
  //         noSwiping: true,
  //         allowSlidePrev: true,
  //         allowSlideNext: true,
  //       },
  //       575: {
  //         slidesPerView: 2,
  //         spaceBetween: 10,
  //         loop: true,
  //         noSwiping: true,
  //         allowSlidePrev: true,
  //         allowSlideNext: true,
  //       },
  //     },
  //   });
  // };

  var _headerscroll = function () {
    $(window).scroll(function () {
      if ($(window).scrollTop() >= 20) {
        if ($(".scrollTop-white").length) {
          $("header").addClass("scrollActive-white");
        }

        if ($(".scrollTop-navy").length) {
          $("header").addClass("scrollActive-navy");
        }
      } else {
        if ($(".scrollTop-white").length) {
          $("header").removeClass("scrollActive-white");
        }

        if ($(".scrollTop-navy").length) {
          $("header").removeClass("scrollActive-navy");
        }
      }
    });
  };

  // var _scrollspyFAQ = function () {

  // }

  var _quotesCarousel = function () {
    var swiper = new Swiper(".swiper-quotation .swiper-container", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 2500,
        // disableOnInteraction: false,
      },
    });
  };

  var _questionsCarousel = function () {
    var swiper = new Swiper(".swiper-questions .swiper-container", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        // disableOnInteraction: false,
      },
    });
  };

  var _openDrugInfo = function () {
    $(".btn-learn").click(function () {
      $(".section-products").addClass("info-open");
      $(this).siblings(".drug-info-holder").toggleClass("js-show-info");
      $("body").addClass("modal-open");
    });
    $(".btn-close").click(function () {
      $(".section-products").removeClass("info-open");
      $(this).parent().removeClass("js-show-info");
      $("body").removeClass("modal-open");
    });
  };

  var _headerMobileNav = function () {
    $("header .navbar-toggler").on("click", function () {
      $("header").toggleClass("is-click");
    });
  };

  var _cardInter = function () {
    $(".section-card .card").on("click", function () {
      $(this).toggleClass("is-click");
      $(this).siblings().removeClass("is-click");
    });

    $(".section-card .card").mouseover(function () {
      $(this).addClass("is-hover");
      $(this).siblings().removeClass("is-hover");
    });

    $(".section-card .card").mouseout(function () {
      $(this).removeClass("is-hover");
    });
  };

  var _bodyLock = function () {
    $(".navbar-toggler").on("click", function () {
      $("body").toggleClass("is-lock");
    });
  };

  var _accordionActive = function () {
    $(".list-group-item").on("click", function () {
      $(this).addClass("active");
      $(this).siblings().removeClass("active");
    });
  };

  var _faqAccordion = function () {
    $(".doctor-ama .list-group-item").on("click", function () {
      var linkAttr = $(this).attr("data-attr");

      var selected = $(".faq-content #" + linkAttr).addClass("is-select");
      selected.siblings().removeClass("is-select");
      var x = document.querySelector(".section-faq");
      var xVal = x.offsetTop;
      var y = document.querySelector("#" + linkAttr);
      var yVal = y.offsetTop;
      var scrollVal = yVal - xVal;
      $("#faq-holder").animate(
        {
          scrollTop: scrollVal - 55,
        },
        1000
      );
    });

    $(window).scroll(function (e) {
      e.preventDefault();

      var activeLink = $(".faq .list-group-item");
      var activeContent = $(".faq .content-holder");
      var scrollPos = $(document).scrollTop();

      activeLink.each(function () {
        var currLink = $(this);
        var refElement = $(currLink.attr("href"));

        if (
          refElement.position().top <= scrollPos &&
          refElement.position().top + refElement.height() > scrollPos + 100
        ) {
          activeLink.removeClass("active");
          activeContent.removeClass("active");
          currLink.addClass("active");
          refElement.addClass("active");
        } else {
          currLink.removeClass("active");
          refElement.removeClass("active");
        }
      });
    });

    $(".doctor-ama .section-faq .faq-content").scroll(function (e) {
      e.preventDefault();

      var activeLink = $(".list-group-item");
      var activeContent = $(this).children();
      var scrollPos = $(document).scrollTop();

      activeLink.each(function () {
        if (scrollPos == 59) {
          $(this).addClass("try");
        }
      });
    });
  };

  /////////////////////
  // Page specific methods //
  ///////////////////

  var initHomepage = function () {
    _revealOnScroll();
    _quotesCarousel();
  };

  var initBetaBlockerPage = function () {
    _revealOnScroll();
  };

  var initAboutPage = function () {
    _revealOnScroll();
  };

  var initSleepPage = function () {
    _cardInter();
  };

  var initSleepProductsPage = function () {
    _openDrugInfo();
  };

  var initFAQPage = function () {
    _accordionActive();
    _faqAccordion();
  };

  var initReviewsPage = function () {
    _quotesCarousel();
  };

  var initDoctorsPage = function () {
    _questionsCarousel();
    _faqAccordion();
    _accordionActive();
  };

  /////////////////////
  // Public Methods //
  ///////////////////
  var init = function () {
    // _scrollToGetStarted();

    // _revealOnScroll();
    // _homePressSwiper();
    _headerscroll();
    // _questionsCarousel();
    // _openDrugInfo();
    _headerMobileNav();
    // _cardInter();
    _bodyLock();
    // _accordionActive();
    // _faqAccordion();
  };

  return {
    init: init,
    initHomepage: initHomepage,
    initBetaBlockerPage: initBetaBlockerPage,
    initSleepPage: initSleepPage,
    initSleepProductsPage: initSleepProductsPage,
    initAboutPage: initAboutPage,
    initDoctorsPage: initDoctorsPage,
    initReviewsPage: initReviewsPage,
  };
})();
